module.exports = __webpack_public_path__ + "static/media/iconComment.c3886d3a.svg";